import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import {
  ALTERNATE_METHOD_EMAIL_LINK,
  ALTERNATE_METHOD_PHONE_LINK,
  ALTERNATE_MODE_LINK_ID,
  PREFERRED_METHOD_EMAIL,
  PREFERRED_METHOD_PHONE,
  RESEND_OTP_LIMIT_EXHAUSTED,
} from "../../Constants/VerifyAccountConstants";
import { useSelector, useDispatch } from "react-redux";
import { manageVerificationSelector } from "../../Selectors/VerificationSelector";
import { BUTTON, DISABLED, INITIAL } from "../../Constants/CommonConstants";
import { postSendOTP } from "../../Features/LoginSlice";
import { StyledAlternateVerificationMethodLink } from "../../Styles/Login/VerifyAccount/VerifyAccountStyles";

/**
 * @description The Alternate Verification Method Link to be displayed when user has registered for both phone and email
 * @param {string} selectedVerificationMethod Specifies the preferred verification method
 * @param {string} previousScreen Specifies the previous screen
 * @param {func} setSelectedVerificationMethod Used to switch the selected verification method
 * @returns {ReactNode} Renders the Alternate Verification Method Link to the user
 */
export const AlternateVerificationMethodLink = ({
  selectedVerificationMethod,
  setSelectedVerificationMethod,
  previousScreen,
}) => {
  const intl = useIntl();

  const dispatch = useDispatch();

  const { sendOTPDescription } = useSelector((state) =>
    manageVerificationSelector(state, previousScreen)
  );

  const alternateMethodLinkClickHandler = () => {
    if (selectedVerificationMethod === PREFERRED_METHOD_EMAIL) {
      setSelectedVerificationMethod(PREFERRED_METHOD_PHONE);
      dispatch(postSendOTP({ otpType: PREFERRED_METHOD_PHONE }));
    } else {
      setSelectedVerificationMethod(PREFERRED_METHOD_EMAIL);
      dispatch(postSendOTP({ otpType: PREFERRED_METHOD_EMAIL }));
    }
  };

  return (
    <StyledAlternateVerificationMethodLink
      id={ALTERNATE_MODE_LINK_ID}
      component={BUTTON}
      onClick={alternateMethodLinkClickHandler}
      linkType={
        sendOTPDescription === RESEND_OTP_LIMIT_EXHAUSTED ? DISABLED : INITIAL
      }
      disabled={sendOTPDescription === RESEND_OTP_LIMIT_EXHAUSTED}
      type={BUTTON}
    >
      {intl.formatMessage({
        id:
          selectedVerificationMethod === PREFERRED_METHOD_EMAIL
            ? ALTERNATE_METHOD_PHONE_LINK
            : ALTERNATE_METHOD_EMAIL_LINK,
      })}
    </StyledAlternateVerificationMethodLink>
  );
};

AlternateVerificationMethodLink.propTypes = {
  /**
   * Specifies the selected verification method
   */
  selectedVerificationMethod: PropTypes.string.isRequired,
  /**
   * Used to toggle the verification method
   */
  setSelectedVerificationMethod: PropTypes.func.isRequired,
  /**
   * Specifies the previous screen
   */
  previousScreen: PropTypes.string.isRequired,
};
